<div class="word-display" (click)="onWordClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>fiber_manual_record</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <ddc-country-flag [ddc_lng]="result.info?.language" [has_label]="false"></ddc-country-flag>
      <span class="article" *ngIf="result.info?.article">{{ result.info.article }}</span>
      <span class="word-label" [innerHTML]="result.label"></span>
      <span class="part-of-speech" *ngIf="result.info?.pos">[{{ result.info.pos }}]</span>
      <ddc-card-category *ngIf="result.info?.category" [category]="result.info.category"></ddc-card-category>
    </div>
  </div>
</div>
